import { Table, TableBody, TableCell, TableRow } from '@mui/material';

export default function AttachmentsReview({ attachments = {} }) {
  const attachmentsArray = [
    { field: 'Most Recent Valuation/Tax Notice', value: attachments.valuation },
    { field: 'Personal Property Equipment List', value: attachments.personal },
    { field: 'Other', value: attachments.other },
  ];
  const attachmentsToRender = attachmentsArray.filter(({ value }) => !!value);
  const hasAttachments = attachmentsArray.reduce(
    (hasAttachments, { value }) => hasAttachments || !!value,
    false
  );
  return !hasAttachments ? (
    <span className="text-red-600">No attachments</span>
  ) : (
    <Table>
      <TableBody>
        {attachmentsToRender.map(({ field, value }, index) =>
          value ? (
            Array.isArray(value) ? (
              value.length > 0 ? (
                <TableRow key={index}>
                  <TableCell>
                    <span className="font-bold">{field}: </span>
                    {value.map((val) => val.name).join(', ')}
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow key={index}>
                  <TableCell>
                    <span className="font-bold">{field}: </span>
                    <span className=" text-gray-400"> Not Provided</span>
                  </TableCell>
                </TableRow>
              )
            ) : (
              <TableRow key={index}>
                <TableCell>
                  <span className="font-bold">{field}: </span>
                  {value.name}
                </TableCell>
              </TableRow>
            )
          ) : null
        )}
      </TableBody>
    </Table>
  );
}
